<template>
<div class="chapter">
<div class="inner_page">
<div id="Acknowledgements">
<p class="fm-title"><b>Author’s Note and Acknowledgements</b></p>
<p class="noindent1">In general it has been found practical to use footnotes largely to identify the sources of quotations; further references appear in the bibliography.</p>
<p class="noindent3">The author extends especial thanks to: Derek Green, Dr John A. Hall, Alan Harrison, and Dennis Sully.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknowledgements.vue?0b1a119b